
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-b13f671e&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./OrbitSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./OrbitSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-b13f671e!../../../../vue-loader/lib/selector?type=template&index=0!./OrbitSpinner.vue"),
  /* scopeId */
  "data-v-b13f671e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/OrbitSpinner.vue
// module id = 868
// module chunks = 1